import { Box, Container, Spacer } from '@chakra-ui/react';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import ActivesNavSidebarContainer from 'presentation/containers/modules/actives/ActivesNavSidebarContainer';
import PersonalManagerChatCard from 'presentation/containers/modules/chat/detail/PersonalManagerChatCard';
import PageLayout from 'presentation/layout/shared/page/PageLayout';
import SidebarLayout from 'presentation/layout/shared/SidebarLayout';
import { FC, PropsWithChildren, ReactNode } from 'react';

interface Props extends PropsWithChildren {
  sidebarContent?: ReactNode | undefined;
}

const ActivesPageLayout: FC<Props> = ({ children, sidebarContent }) => {
  return (
    <PageLayout>
      <Container display="flex" alignItems="flex-start">
        <SidebarLayout>
          <ActivesNavSidebarContainer />
          {sidebarContent && (
            <>
              <Spacer h="20px" />
              {sidebarContent}
            </>
          )}
          <PersonalManagerChatCard
            mt="20px"
            roomType={ChatRoomType.PersonalManager}
          />
        </SidebarLayout>
        <Box flex="1">{children}</Box>
      </Container>
    </PageLayout>
  );
};

export default ActivesPageLayout;
